/* eslint-disable import/named,import/prefer-default-export */
import { createSlice } from '@reduxjs/toolkit';
import { TLotEditorSelected } from '../../../../share/types';

const initialState: TLotEditorSelected = {
  selected: undefined,
  isShowLengthPopper: false,
};

const lotGuiSelectorSlice = createSlice({
  name: 'lotGuiSelector',
  initialState,
  reducers: {
    onSelectAction(slice, { payload }: { payload: string }) {
      return ({
        ...slice, selected: payload,
      });
    },
    onUnselectAction(slice) {
      return ({
        ...slice, selected: undefined,
      });
    },
    showLengthPoppersAction(slice) {
      return ({
        ...slice, isShowLengthPopper: true,
      });
    },
    hideLengthPoppersAction(slice) {
      return ({
        ...slice, isShowLengthPopper: false,
      });
    },
    resetGuiState(slice) {
      return ({
        ...slice,
        selected: undefined,
        isShowLengthPopper: false,
      });
    },
  },
});
export const lotGuiSelectorReducer = lotGuiSelectorSlice.reducer;

export const {
  onSelectAction,
  onUnselectAction,
  showLengthPoppersAction,
  hideLengthPoppersAction,
  resetGuiState,
} = lotGuiSelectorSlice.actions;
